import Vue from 'vue'
import 'vux-styles/reset.less'
import 'vux-styles/1px.less'
import Icon from 'vux-comp/icon'
import XButton from 'vux-comp/x-button'
import XInput from 'vux-comp/x-input'
import XHeader from 'vux-comp/x-header'
import XDialog from 'vux-comp/x-dialog'
import Popup from 'vux-comp/popup'
import Group from 'vux-comp/group'
import Cell from 'vux-comp/cell'
import Alert from 'vux-comp/alert'
import AlertPlugin from 'vux-plugins/alert'
import LoadingPlugin from 'vux-plugins/loading'
import ToastPlugin from 'vux-plugins/toast'
import ConfirmPlugin from 'vux-plugins/confirm'

Vue.component('cell', Cell)
Vue.component('icon', Icon)
Vue.component('alert', Alert)
Vue.component('x-button', XButton)
Vue.component('x-dialog', XDialog)
Vue.component('group', Group)
Vue.component('x-input', XInput)
Vue.component('x-head', XHeader)
Vue.component('popop', Popup)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin, { width: '50%', position: 'middle' })
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)

import Checkbox from 'vant/lib/checkbox'
import CheckboxGroup from 'vant/lib/checkbox-group'
import VantPopup from 'vant/lib/popup'
import Dialog from 'vant/lib/dialog'
import VanIcon from 'vant/lib/icon'
import Button from 'vant/lib/button'
import NumberKeyboard from 'vant/lib/number-keyboard'
import Toast from 'vant/lib/toast'
import Radio from 'vant/lib/radio'
import RadioGroup from 'vant/lib/radio-group'
import Picker from 'vant/lib/picker'
import Switch from 'vant/lib/switch'
import Loading from 'vant/lib/loading'
import Collapse from 'vant/lib/collapse'
import CollapseItem from 'vant/lib/collapse-item'

// import Stepper from 'vant/lib/stepper'
import 'vant/lib/checkbox/style'
import 'vant/lib/checkbox-group/style'
import 'vant/lib/popup/style'
import 'vant/lib/dialog/style'
import 'vant/lib/icon/style'
import 'vant/lib/number-keyboard/style'
import 'vant/lib/toast/style'
import 'vant/lib/radio/style'
import 'vant/lib/radio-group/style'
import 'vant/lib/picker/style'
import 'vant/lib/switch/style'
import 'vant/lib/loading/style'
import 'vant/lib/collapse/style'
import 'vant/lib/collapse-item/style'

Vue.use(Toast)
// import 'vant/lib/stepper/style'
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dialog)
// Vue.use(Stepper)
Vue.use(VantPopup)
Vue.use(VanIcon)
Vue.use(Button)
Vue.use(NumberKeyboard)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(Loading)
Vue.use(Collapse)
Vue.use(CollapseItem)
